import React from 'react'
import Loadable from 'react-loadable'
import actions from 'redux/actions'
import { useCallback } from 'sb-hooks'
import { constants, links, localStorage } from 'common/helpers'

import auth from 'decorators/auth'

import { Loader } from 'components/_new/ui'
import { MainSection, WidthContainer, Box } from 'components/_new/layout'

import Content from 'components/auth/Content/Content'
import Text from 'components/_new/typography/Text/Text'
import Title from 'components/_new/typography/deprecated/Title/Title'

import RecoverPasswordForm from './RecoverPasswordForm/RecoverPasswordForm'

import messages from './messages'
import s from './RecoverPasswordPage.scss'


const loading = Loader
const WithoutHeaderLayout = Loadable({ loader: () => import('layouts/WithoutHeaderLayout/WithoutHeaderLayout'), loading })


const RecoverPasswordPage = () => {
  const onBackLinkClick = useCallback(() => {
    actions.models.router.push(links.login)
  }, [])

  const logoLink = localStorage.getSessionItem(constants.localStorageNames.authLogoRedirectUrl)

  const onLogoClick = useCallback(() => {
    localStorage.removeSessionItem(constants.localStorageNames.authLogoRedirectUrl)
  }, [])

  return (
    <WithoutHeaderLayout
      logoLink={logoLink}
      withFooter
      onLogoClick={onLogoClick}
    >
      <WidthContainer>
        <MainSection alignCenter>
          <Content>
            <Title message={messages.title} size="lg" uppercase html />
            <Box mt={16} className={s.text}>
              <Text
                size="16-24"
                message={messages.text}
              />
            </Box>
            <RecoverPasswordForm onClickBackLink={onBackLinkClick} />
          </Content>
        </MainSection>
      </WidthContainer>
    </WithoutHeaderLayout>
  )
}


export default auth(RecoverPasswordPage)
